export default "__VITE_ASSET__79vx94pk__"